/**
 * Example where we don't wanna redirect 
 * only we wanna show message in snackbar
 * 
 * let response = await ProductService.updateItem(
                this.item.product_id,
                data
            )
    this.snackResponseSubmit(response,'Producto Editado')
 * 
 */
import {mapActions, mapState} from 'vuex'
export default {
    computed: {
        ...mapState('SnackbarModalModule', {'responseConfirmSnackbar': 'responseConfirm'})
    },
    methods:{
        fillSnack( typeMessage, titleMsg, bodyMsg,  showProgress=false, timeout=0, showCloseBtn=true ,closeBtnMessage="cerrar" ){
            let payloadSnack = {
                typeMessage: typeMessage,
                message : {
                    title : titleMsg,
                    body : bodyMsg,
                },
                timeout : timeout,
                showProgress : showProgress,
                showCloseBtn : showCloseBtn,
                closeBtnMessage : closeBtnMessage,
            }
            return payloadSnack
        },
        snackLoading(tittleMsg, bodyMsg){
            this.resetSnackbarState()
            this.initSnackbar(this.fillSnack('info', tittleMsg, bodyMsg, true))
        },
        snackInfoResponse(status, tittleMsg, bodyMsg){
            this.resetSnackbarState()
            this.initSnackbar(this.fillSnack('info', tittleMsg, bodyMsg, true))
        },
        /**
         *@params response (response give it for service)
         *@params actionDone (if action has success , what message we want to display )
         *@params redirectRoute (if action has success , where we wanna redirect(OPTIONAL))
         *@returns boolean 
         */
        snackResponseSubmit(response, actionDone, redirectRoute = null) {
            if (response.status === 'success' || response.status === 200) {
                const msg = `${actionDone} exitosamente`
                this.successMessage(msg)
                if (redirectRoute) {
                    this.redirectTo(redirectRoute)
                }
                return true 
            } else{
                this.errorMessage(response)
                return false
            }      
        },
        cleanFolio(){

        },
        /**
         *
         */
        successMessage(message) {
            this.resetSnackbarState()
            this.initSnackbar(
                this.fillSnack('success', 'Éxito', message, false, 5000)
            )
        },
        /**
         *
         */
        errorMessage(response) {
            this.resetSnackbarState()
            if (response.error)
                this.initSnackbar(
                    this.fillSnack(
                        'error',
                        'Error',
                        response.error,
                        false,
                        5000
                    )
                )
            else if(response.errors)
                this.initSnackbar(
                    this.fillSnack(
                        'error',
                        'Error',
                        response.errors,
                        false,
                        5000
                    )
                )
            else if (response.data.error)
                this.initSnackbar(
                    this.fillSnack(
                        'error',
                        'Error',
                        response.data.error,
                        false,
                        5000
                    )
                )
            else
                this.initSnackbar(
                    this.fillSnack(
                        'error',
                        'Error',
                        'Ha ocurrido un error al enviar los datos al servidor',
                        false,
                        5000
                    )
                )
        },
        /**
         *
         */
        redirectTo(route) {
            this.$router.push(route)
        },

        /* vuex */
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        /**
         * Sets the selected.
         *
         * @param      {<type>}  item    The item
         */
        async setSelected(item) {
            this.selected = item
        },

        /**
         * Sets the title.
         *
         * @param      {<type>}  opts    The options
         * @return     {<type>}  { description_of_the_return_value }
         */
        setTitle(opts) {
            return this.$store.dispatch('MenuesModule/setTitleTopBar', opts)
        },

        /**
         * Sets the title.
         *
         * @param      {<type>}  opts    The options
         * @return     {<type>}  { description_of_the_return_value }
         */
        setItems(opts) {
            return this.$store.dispatch('MenuesModule/setItemsTopBar', opts)
        },

        /**
         * Shows the error snackbar.
         *
         * @param      {<type>}  opts    The options
         * @return     {<type>}  { description_of_the_return_value }
         */
        showErrorSnackbar(opts) {
            return this.$store.dispatch('SnackbarModalModule/setErrorSnackbar', opts)
        },

        /**
         * Shows the info snackbar.
         *
         * @param      {<type>}  opts    The options
         * @return     {<type>}  { description_of_the_return_value }
         */
        showInfoSnackbar(opts) {
            return this.$store.dispatch('SnackbarModalModule/setInfoSnackbar', opts)
        },

        /**
         * Shows the success snackbar.
         *
         * @param      {<type>}  opts    The options
         * @return     {<type>}  { description_of_the_return_value }
         */
        showSuccessSnackbar(opts) {
            return this.$store.dispatch('SnackbarModalModule/setSuccessSnackbar', opts)
        },

        /**
         * Shows the warning snackbar.
         *
         * @param      {<type>}  opts    The options
         * @return     {<type>}  { description_of_the_return_value }
         */
        showWarningSnackbar(opts) {
            return this.$store.dispatch('SnackbarModalModule/setWarningSnackbar', opts)
        },

        /**
         * Shows the waiting snackbar.
         *
         * @param      {<type>}  opts    The options
         * @return     {<type>}  { description_of_the_return_value }
         */
        showWaitingSnackbar(opts) {
            return this.$store.dispatch('SnackbarModalModule/setWaitingSnackbar', opts)
        },

        /**
         * { function_description }
         *
         * @return     {<type>}  { description_of_the_return_value }
         */
        showProgressSnackbarState() {
            return this.$store.dispatch('SnackbarModalModule/setProgressSnackbarState')
        },
    },
}
